import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import chicaImg from "../../assets/img/lucia.png";
import chicosImg from "../../assets/img/ninos.png";
import { FaWhatsapp } from "react-icons/fa";

const Presencia = () => {
  return (
    <section className="presencia seccion-vida ">
      <Container fluid className="py-5 px-md-5">
        <Row>
          <Col md={11} xs={11} className="mx-auto text-center mb-4">
            {/* Parte superior: Gastos Médicos */}
            <Row className="align-items-center mb-5">
              <Col md={6} className="text-start mb-4 mb-md-0 ps-md-5">
                <div className="d-flex align-items-center mb-3">
                  <span className="icon-individual me-2"></span>
                  <h6 className="subtitle m-0 fw-bold">Protección individual</h6>
                </div>
                <h2 className="text-primary fw-bold pt-3">Gastos Médicos</h2>
                <p>
                  La protección de Gastos Médicos <strong>tiene como función protegerte</strong> ante alguna enfermedad
                  o accidente. Cubre los gastos de atención médica, cirugías, medicina, análisis clínicos, entre otros
                  servicios.
                </p>
                <p className="mb-3 fw-semibold">
                  Si estás interesado, da clic aquí y permítenos asesorarte mediante una llamada o videollamada.
                </p>
                <a
                  href="https://api.whatsapp.com/send?phone=5215552030377&text=Hola%2C%20solicito%20informaci%C3%B3n%20detallada%20sobre%20la%20cobertura%20de%20Gastos%20M%C3%A9dicos.%20Vi%20la%20info%20en%20su%20Portal%20Web.%20%F0%9F%8C%90"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-comunicate d-inline-flex align-items-center gap-2 mt-3 boton-hogar"
                >
                  <FaWhatsapp />
                  Quiero comunicarme
                </a>
              </Col>
              <Col md={6} className="text-center d-md-block d-none">
                <img src={chicaImg} alt="Profesora" className="img-fluid chica" />
              </Col>
            </Row>

            {/* Parte inferior: Protección de vida */}
            <div className="py-5 px-3 px-md-5 pb-0">
              <Row className="align-items-center">
                <Col md={7} className="text-center text-md-start mb-4 mb-md-0 d-md-block d-none">
                  <img src={chicosImg} alt="Niños protegidos" className="img-fluid ninos" />
                </Col>
                <Col md={5} className="text-start">
                  <h3 className="text-primary fw-bold">Protección de vida</h3>
                  <p>
                    Ante una posible eventualidad, le garantiza al asegurado y a sus beneficiarios un respaldo
                    económico. Dando tranquilidad pase lo que pase.
                  </p>
                  <p className="fw-semibold">
                    Si estás interesado, da clic aquí y permítenos asesorarte mediante una llamada o videollamada.
                  </p>
                  <a
                    href="https://api.whatsapp.com/send?phone=5215552030377&text=Hola%2C%20solicito%20informaci%C3%B3n%20detallada%20sobre%20la%20cobertura%20de%20Vida.%20Vi%20la%20info%20en%20su%20Portal%20Web.%20%F0%9F%8C%90"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-comunicate d-inline-flex align-items-center gap-2 mt-3 boton-hogar"
                  >
                    <FaWhatsapp />
                    Quiero comunicarme
                  </a>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Presencia;
